<template>
    <div class="terms-conditions ptb-100">
        <div class="container">
            <div class="single-privacy">
                <h3 class="mt-0">Lorem Ipsum</h3>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. scrambled it to make a type specimen book. It has survived not only five centuries.</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TermsConditionsContent'
}
</script>